import axios from 'axios';
import * as Sentry from "@sentry/vue";
import stateMerge from "@/store/object-merge";
import app from "../../api/app";
import { uuidv7 } from "uuidv7";

// initial state
const state = {
    user: null,
    token: null,
    instance: null,
    device: null,
    devices: [],
    rules: [],
    permissions: {},
    loaded: null,
    redirectData: null,
};

// getters
const getters = {
    isUser: state => {
        return state.user !== null;
    },
    isDevice: state => {
        return state.device !== null;
    },
    hasDevices: state => {
        return state.devices.length > 0;
    },
    userCan: (state, getters, rootState) => (action) => {
        if (action === 'device.all') {
            return state.user.baseId === rootState.bases.centralBaseId;
        }
        return false;
    },
    fullName: state => {
        return state.user !== null ? state.user.firstName + ' ' + state.user.lastName : 'nepřihlášen';
    },
    id: state => {
        return state.user.id;
    },
    token: state => {
        return state.user ? 'Bearer ' + state.token : null;
    },
    instance: state => {
        return state?.instance;
    },
    config: state => {
        return {
            headers: app.getAuthHeaders(),
        }
    },
};

// actions
const actions = {
    login({commit, rootState, dispatch}, payLoad) {
        return axios.post(
            process.env.VUE_APP_TEREZA_API_URL + '/v2/auth/login',
            payLoad,
            {
                headers: {
                    panel: true
                }
            }
        ).then(
            (response) => {
                if (response.data.result === 'success') {

                    const payload = response.data;
                    payload.version = rootState.app.version;
                    payload.code = rootState.app.code;
                    payload.instance = uuidv7();

                    commit('setUser', payload);
                    dispatch('setIdentity');
                    return response.data;
                } else if (response.data.result === 'denied') {
                    commit('setRedirectData', response.data);
                    return response.data;
                } else {
                    throw new Error(response.data.message);
                }

            },
            (error) => {
                if (error.response?.data?.result === 'denied') {
                    commit('setRedirectData', error.response.data);
                    return error.response.data;
                }
                throw new Error('Chyba při autorizaci');
            }
        )
    },
    logout({commit, dispatch}) {
        commit('logout');
        dispatch('app/resetState', null, {root: true});
        commit('panel/resetState', null, {root: true});

        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({
                type: 'SET_TOKEN',
                token: null
            })
        }
    },
    setIdentity({state, commit}) {
        Sentry.setUser({
            id: state.user.id,
            username: state.user.username,
            baseId: state.user.baseId,
        });
        commit('setIdentity', {roles: state.user.roles, groups: state.user.groups, baseId: state.user.baseId});

        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({
                type: 'SET_TOKEN',
                token: state.token
            })
        }
    },
    setDevice({state, commit}, payload) {
        commit('setDevice', payload);
        Sentry.setContext("Device", {
            id: state.device.id,
            name: state.device.name,
            code: state.device.code,
        });
    },
    async setUserPermissions({commit}, payload) {
        if (payload)
            commit("MERGE_STATE", payload)
    },
    setRedirectData({commit}, payload) {
        commit('setRedirectData', payload);
    },
    clearRedirectData({commit}) {
        commit('setRedirectData', null);
    },
};

// mutations
const mutations = {
    MERGE_STATE(state, data) {
        stateMerge(state, data, 'permissions')
    },
    setUser(state, payload) {
        state.user = payload.user;
        state.token = payload.message;
        state.instance = payload.instance;
        state.device = null;
        state.devices.push(payload.device);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + payload.message;
        axios.defaults.headers.common['app-code'] = payload.code;
        // axios.defaults.headers.common['app-version'] = payload.version;
        axios.defaults.headers.common['app-instance'] = state.instance;
    },
    setIdentity(state, payload) {
        state.rules = payload;
    },
    setDevice(state, payload) {
        state.device = payload;
    },
    setRedirectData(state, payload) {
        state.redirectData = payload;
    },
    logout(state) {
        state.user = null;
        state.device = null;
        state.instance = null;
        state.devices = [];
        state.permissions = {};
        state.redirectData = null;
        Sentry.configureScope(scope => scope.setUser(null));
    },
    resetState(state, payload) {
        Object.assign(state, payload);
    },
    resetPermissions(state) {
        state.permissions = {};
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
